import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShuffleIcon } from 'lucide-react';
import { Card, drawCard } from './utils/stones';
import { GameCard } from './components/GameCard';
import { PasswordGate } from './components/PasswordGate';
export function App() {
  const [card, setCard] = useState<Card | null>(null);
  useEffect(() => {
    setCard(drawCard());
  }, []);
  const draw = () => setCard(drawCard());
  return <PasswordGate data-id="element-0">
      <div className="flex min-h-full w-full justify-center bg-slate-100" data-id="element-1">
        <div className="flex min-h-full w-full max-w-md flex-col" data-id="element-2">
          <header className="px-4 pt-8 pb-2 text-center" data-id="element-3">
            <h1 className="text-2xl font-extrabold tracking-tight text-slate-800" data-id="element-4">
              Steinkarte
            </h1>
            <p className="mt-0.5 text-sm text-slate-500" data-id="element-5">
              {card ? `${card.stones.length} Steine` : 'Karte wird gezogen…'}
            </p>
          </header>

          <main className="flex flex-1 items-center justify-center px-8 py-4" data-id="element-6">
            <div className="w-full max-w-[240px]" data-id="element-7">
              <AnimatePresence mode="wait" data-id="element-8">
                {card && <GameCard key={card.id} card={card} index={0} data-id="element-9" />}
              </AnimatePresence>
            </div>
          </main>

          <footer className="sticky bottom-0 border-t border-slate-200 bg-slate-100/90 p-4 backdrop-blur" data-id="element-10">
            <motion.button type="button" onClick={draw} whileTap={{
            scale: 0.97
          }} className="flex w-full items-center justify-center gap-2 rounded-xl bg-slate-900 px-5 py-3.5 text-base font-semibold text-white shadow-lg active:bg-slate-800" data-id="element-11">
              <ShuffleIcon className="h-5 w-5" data-id="element-12" />
              Neue Karte ziehen
            </motion.button>
          </footer>
        </div>
      </div>
    </PasswordGate>;
}